import React from 'react';
import { useLeadersContext } from '../state/leaders';

export default function LeaderIcons({ leaderIds }: { leaderIds: string[] }) {
  const { getLeadersById } = useLeadersContext();
  const leaders = getLeadersById(leaderIds);

  return (
    <>
      {leaders.map((leader) => (
        <div className='modal-leader' key={leader.uid}>
          <img
            src={leader.image || 'https://png.pngtree.com/png-vector/20190307/ourlarge/pngtree-vector-add-user-icon-png-image_762930.jpg'}
            alt={leader.name}
          />
          <div>{leader.name} </div>
        </div>
      ))}
    </>
  );
}
